/* import __COLOCATED_TEMPLATE__ from './company-billing-features.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';

const YES_OPTION_LABEL = 'YES';
const NO_OPTION_LABEL = 'NO';

const YES_NO_OPTION_LABELS = {
  0: NO_OPTION_LABEL,
  1: YES_OPTION_LABEL,
};

const YES_NO_OPTIONS = [
  {
    key: YES_NO_OPTION_LABELS[1],
    model: 1,
  },
  {
    key: YES_NO_OPTION_LABELS[0],
    model: 0,
  },
];

class AdminCompanyBillingFeatures extends Component {
  get featureDefaults() {
    const { companyBillingDefaults, companyTierVersion, companyTier } = this.args;
    return companyBillingDefaults[companyTierVersion][companyTier].features;
  }

  get options() {
    return YES_NO_OPTIONS;
  }

  get booleanOptionLabels() {
    return YES_NO_OPTION_LABELS;
  }

  get advancesValue() {
    return this.args.currentValues.advances ?? this.featureDefaults.advances;
  }

  get alwaysCoverFeesValue() {
    return this.args.currentValues.always_cover_fees ?? this.featureDefaults.always_cover_fees;
  }

  get canSearchValue() {
    return this.args.currentValues.can_search ?? this.featureDefaults.can_search;
  }

  get inviteMaxValue() {
    return this.args.currentValues.invite_max;
  }

  get inviteMaxDescription() {
    return this.featureDefaults.invite_max ?? 'Unlimited';
  }

  get inviteMaxDisabled() {
    return this.args.disabled || this.inviteMaxInfiniteChecked;
  }

  get inviteMaxInfiniteChecked() {
    return this.inviteMaxValue === null;
  }

  get inviteMaxChanged() {
    return this.args.changedValues.invite_max;
  }

  get invoiceReceiptsValue() {
    return this.args.currentValues.invoice_receipts ?? this.featureDefaults.invoice_receipts;
  }

  get usesCompanyTeamsValue() {
    return this.args.currentValues.uses_company_teams ?? this.featureDefaults.uses_company_teams;
  }

  get usesBrandsValue() {
    return this.args.currentValues.brands ?? this.featureDefaults.brands;
  }

  get usesCostCodesValue() {
    return this.args.currentValues.uses_cost_codes ?? this.featureDefaults.uses_cost_codes;
  }

  get requiresCostCodesValue() {
    return this.args.currentValues.requires_cost_codes ?? this.featureDefaults.requires_cost_codes;
  }

  get creditsValue() {
    return this.args.currentValues.credits ?? this.featureDefaults.credits;
  }

  get directMessageValue() {
    return this.args.currentValues.direct_message ?? this.featureDefaults.direct_message;
  }

  get expensesValue() {
    return this.args.currentValues.expenses ?? this.featureDefaults.expenses;
  }

  get lockoutOverrideValue() {
    return this.args.currentValues.lockout_override ?? this.featureDefaults.lockout_override;
  }

  get publicProjectsValue() {
    return this.args.currentValues.public_projects ?? this.featureDefaults.public_projects;
  }

  get reportsValue() {
    return this.args.currentValues.reports ?? this.featureDefaults.reports;
  }

  get requiresPostingApprovalValue() {
    return this.args.currentValues.requires_posting_approval ?? this.featureDefaults.requires_posting_approval;
  }

  @action
  onNetworkCapacityInfiniteClicked() {
    if (this.inviteMaxInfiniteChecked) {
      // reset to default or zero value if null
      const resetValue = this.featureDefaults.invite_max ?? 0;
      this.args.onChangeFeature('invite_max', resetValue);
    } else {
      this.args.onChangeFeature('invite_max', null);
    }
  }

  @action
  onChangeFeatureWrapper() {
    if (this.inviteMaxValue === '') {
      this.args.onChangeFeature('invite_max', null);
    }
  }
}

export default AdminCompanyBillingFeatures;
